import { render } from "./studioCourseManager.vue?vue&type=template&id=9c9c11de&scoped=true"
import script from "./studioCourseManager.vue?vue&type=script&lang=js"
export * from "./studioCourseManager.vue?vue&type=script&lang=js"

import "./studioCourseManager.vue?vue&type=style&index=0&id=9c9c11de&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9c11de"]])

export default __exports__